<div class="db-image-limits-banner" [ngClass]="{'loading': (loading && !pageLayout)}">
  <ng-container [ngTemplateOutlet]="limitNotReached"
                *ngIf="stats?.planLimit > stats?.usedCountFromLimit"></ng-container>
  <ng-container [ngTemplateOutlet]="limitReached" *ngIf="!(stats?.planLimit > stats?.usedCountFromLimit)"></ng-container>
</div>

<ng-template #limitReached>
  <div class="db-image-limits-banner-header"
       [ngClass]="{'ds-lazy-load': !(optimizeImagesStats$ | async) && !pageLayout}">
    <h3 class="mb4">The optimization limit for this month has been exceeded</h3>
    <p>Upgrade now to receive unlimited image optimization.</p>
  </div>

  <div class="db-image-limits-banner-limits"
       [ngClass]="{'ds-lazy-load': !(optimizeImagesStats$ | async) && !pageLayout}">
    <button class="ds-btn-green ds-btn-m" [routerLink]="['/upgrade-plan']" (click)="sendEvent('Dashboard Action', 'Upgrade button click' , 'Images limit exceeded (banner)')"><span>Upgrade</span></button>
  </div>
</ng-template>


<ng-template #limitNotReached>
  <div class="db-image-limits-banner-header"
       [ngClass]="{'ds-lazy-load': !(optimizeImagesStats$ | async) && !pageLayout}">
    <h3 class="mb4">Free plan</h3>
    <p>Includes optimization of {{stats?.planLimit /1000 + 'K'}} images per month</p>
  </div>

  <div class="db-image-limits-banner-limits"
       [ngClass]="{'ds-lazy-load': !(optimizeImagesStats$ | async) && !pageLayout}">
    <h3 class="mb4" [innerHTML]="(stats?.usedCountFromLimit >= 10000 ? (stats?.usedCountFromLimit | count) : stats?.usedCountFromLimit) + ' of ' + (stats?.planLimit | count) + ' optimized'"></h3>
    <p>Next reset: {{stats?.limitResetDate | date}}</p>
  </div>
</ng-template>
